(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-tiles"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(slider) {
      var track   = slider.querySelector('.category-tiles__track');
      var cards   = track.querySelectorAll('.category-tiles__card');
      var prevBtn = slider.querySelector('.category-tiles__btn--prev');
      var nextBtn = slider.querySelector('.category-tiles__btn--next');

      if (cards.length < 2) {
        if (prevBtn) prevBtn.hidden = true;
        if (nextBtn) nextBtn.hidden = true;
        return;
      }

      var total        = cards.length;
      var currentIndex = 0;
      var timer        = null;

      function getCardWidth() {
        var gap = parseFloat(getComputedStyle(track).gap) || 8;
        return cards[0].offsetWidth + gap;
      }

      function canScroll() {
        return track.scrollWidth > track.clientWidth + 1;
      }

      function updateArrows() {
        if (!prevBtn || !nextBtn) return;
        var scrollable = canScroll();
        prevBtn.hidden = !scrollable;
        nextBtn.hidden = !scrollable;
      }

      function goTo(index) {
        if (index >= total) index = 0;
        if (index < 0) index = total - 1;
        currentIndex = index;
        track.scrollTo({ left: currentIndex * getCardWidth(), behavior: 'smooth' });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { stopAuto(); goTo(currentIndex - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { stopAuto(); goTo(currentIndex + 1); });

      function startAuto() {
        if (window.innerWidth >= 750) return;
        stopAuto();
        timer = setInterval(function () { goTo(currentIndex + 1); }, 3000);
      }

      function stopAuto() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      track.addEventListener('touchstart', function () { stopAuto(); }, { passive: true });
      track.addEventListener('touchend', function () {
        setTimeout(function () {
          currentIndex = Math.round(track.scrollLeft / getCardWidth());
          startAuto();
        }, 500);
      }, { passive: true });

      updateArrows();
      window.addEventListener('resize', updateArrows);
      startAuto();
    }

    document.querySelectorAll('.category-tiles__slider').forEach(initCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel-3-banners"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initHeroCarousel = (section) => {
      if (!section || section.dataset.carouselInitialized === 'true') return;

      const track = section.querySelector('[data-carousel-track]');
      const slides = section.querySelectorAll('[data-carousel-slide]');
      const prevButton = section.querySelector('[data-carousel-prev]');
      const nextButton = section.querySelector('[data-carousel-next]');
      const dots = section.querySelectorAll('[data-carousel-dot]');

      if (!track || slides.length <= 1) return;

      section.dataset.carouselInitialized = 'true';

      let currentIndex = 0;
      let autoplayTimer = null;
      const autoplay = section.dataset.autoplay === 'true';
      const autoplaySpeed = Number(section.dataset.autoplaySpeed) || 5000;

      const goTo = (index) => {
        currentIndex = (index + slides.length) % slides.length;

        track.style.transform = `translate3d(-${currentIndex * 100}%, 0, 0)`;

        slides.forEach((slide, index) => {
          slide.setAttribute('aria-hidden', index === currentIndex ? 'false' : 'true');
        });

        dots.forEach((dot, index) => {
          const active = index === currentIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };

      const stopAutoplay = () => {
        if (autoplayTimer) {
          window.clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      };

      const startAutoplay = () => {
        stopAutoplay();

        if (!autoplay) return;

        autoplayTimer = window.setInterval(() => {
          goTo(currentIndex + 1);
        }, autoplaySpeed);
      };

      const restartAutoplay = () => {
        stopAutoplay();
        startAutoplay();
      };

      prevButton?.addEventListener('click', () => {
        goTo(currentIndex - 1);
        restartAutoplay();
      });

      nextButton?.addEventListener('click', () => {
        goTo(currentIndex + 1);
        restartAutoplay();
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          goTo(Number(dot.dataset.carouselDot));
          restartAutoplay();
        });
      });

      let touchStartX = 0;
      let touchEndX = 0;

      section.addEventListener(
        'touchstart',
        (event) => {
          touchStartX = event.changedTouches[0].screenX;
          stopAutoplay();
        },
        { passive: true }
      );

      section.addEventListener(
        'touchend',
        (event) => {
          touchEndX = event.changedTouches[0].screenX;

          const distance = touchEndX - touchStartX;

          if (Math.abs(distance) > 50) {
            if (distance < 0) {
              goTo(currentIndex + 1);
            } else {
              goTo(currentIndex - 1);
            }
          }

          startAutoplay();
        },
        { passive: true }
      );

      section.addEventListener('mouseenter', stopAutoplay);
      section.addEventListener('mouseleave', startAutoplay);

      section.addEventListener('focusin', stopAutoplay);
      section.addEventListener('focusout', startAutoplay);

      goTo(0);
      startAutoplay();

      document.addEventListener('shopify:section:unload', (event) => {
        if (event.detail?.sectionId === section.dataset.sectionId) {
          stopAutoplay();
        }
      });
    };

    const initAll = () => {
      document.querySelectorAll('.hero-carousel').forEach(initHeroCarousel);
    };

    initAll();

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector?.('.hero-carousel');

      if (section) {
        initHeroCarousel(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
    
(function () {
  function closeAll() {
    document.querySelectorAll('.lookbook-panel.is-open').forEach(function (p) {
      p.classList.remove('is-open');
      p.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('.lookbook-overlay').forEach(function (o) {
      o.classList.remove('is-visible');
      setTimeout(function () { o.style.display = 'none'; }, 320);
    });
    document.body.style.overflow = '';
  }

  function openPanel(panelId, sectionId) {
    closeAll();
    var panel = document.getElementById(panelId);
    var overlay = document.getElementById('lookbook-overlay-' + sectionId);
    if (!panel || !overlay) return;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    overlay.style.display = 'block';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        overlay.classList.add('is-visible');
      });
    });
    document.body.style.overflow = 'hidden';
  }

  function showMsg(card, text, isError) {
    var msg = card.querySelector('.lookbook-panel__msg');
    if (!msg) return;
    msg.textContent = text;
    msg.style.color = isError ? '#c00' : '#4a7c59';
    if (text) setTimeout(function () { msg.textContent = ''; }, 3000);
  }

  function addToCart(variantId, addBtn, card) {
    addBtn.disabled = true;
    addBtn.classList.add('is-loading');
    var original = addBtn.textContent;
    addBtn.textContent = 'Adicionando...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (res) { return res.json(); })
    .then(function (data) {
      if (data.status && data.status !== 200) throw new Error(data.description || 'Erro');
      addBtn.classList.remove('is-loading');
      addBtn.classList.add('is-success');
      addBtn.textContent = 'Adicionado ✓';
      showMsg(card, '', false);

      /* Atualiza contagem no header */
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count], .cart-count-bubble, .cart-item-count').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
        });

      setTimeout(function () {
        addBtn.classList.remove('is-success');
        addBtn.disabled = false;
        addBtn.textContent = original;
      }, 2500);
    })
    .catch(function () {
      addBtn.classList.remove('is-loading');
      addBtn.disabled = false;
      addBtn.textContent = original;
      showMsg(card, 'Não foi possível adicionar. Tente novamente.', true);
    });
  }

  document.addEventListener('click', function (e) {
    /* Abrir painel */
    var gridItem = e.target.closest('.lookbook__item--has-products');
    if (gridItem && gridItem.dataset.panel) {
      openPanel(gridItem.dataset.panel, gridItem.dataset.section);
      return;
    }

    /* Fechar painel */
    if (e.target.closest('.lookbook-panel__close')) { closeAll(); return; }
    if (e.target.classList.contains('lookbook-overlay')) { closeAll(); return; }

    /* Selecionar tamanho */
    var sizeBtn = e.target.closest('.lookbook-panel__size-btn');
    if (sizeBtn && !sizeBtn.disabled) {
      var sizesEl = sizeBtn.closest('.lookbook-panel__sizes');
      var card = sizeBtn.closest('.lookbook-panel__product');
      sizesEl.querySelectorAll('.lookbook-panel__size-btn').forEach(function (b) { b.classList.remove('is-selected'); });
      sizeBtn.classList.add('is-selected');

      var variantsScript = card.querySelector('.lookbook-variants-json');
      var addBtn = card.querySelector('.lookbook-panel__add-btn');
      if (variantsScript && addBtn) {
        var variants = JSON.parse(variantsScript.textContent);
        var selected = sizeBtn.dataset.option;
        var match = null;
        for (var v = 0; v < variants.length; v++) {
          if (variants[v].o1 === selected && variants[v].available) { match = variants[v]; break; }
        }
        if (match) {
          addBtn.dataset.variantId = match.id;
          addBtn.disabled = false;
          addBtn.textContent = 'Adicionar ao carrinho';
        } else {
          delete addBtn.dataset.variantId;
          addBtn.disabled = true;
          addBtn.textContent = 'Esgotado nesse tamanho';
        }
      }
      return;
    }

    /* Adicionar ao carrinho */
    var addBtn = e.target.closest('.lookbook-panel__add-btn');
    if (addBtn && !addBtn.disabled) {
      var variantId = addBtn.dataset.variantId;
      var card = addBtn.closest('.lookbook-panel__product');
      if (!variantId) {
        showMsg(card, 'Selecione um tamanho antes de adicionar.', true);
        return;
      }
      addToCart(variantId, addBtn, card);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["perks-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPerksCarousel() {
      document.querySelectorAll('[data-perks-bar]').forEach(function (bar) {
        var items = Array.from(bar.querySelectorAll('.perks-bar__item'));
        if (items.length <= 1) return;
        if (!window.matchMedia('(max-width: 749px)').matches) return;

        var current = 0;
        items[0].classList.add('is-active');

        setInterval(function () {
          items[current].classList.remove('is-active');
          current = (current + 1) % items.length;
          items[current].classList.add('is-active');
        }, 4000);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPerksCarousel);
    } else {
      initPerksCarousel();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {

    document.querySelectorAll('.products-grid__card').forEach(function (card) {
      var secondary = card.querySelector('.products-grid__img--secondary');
      if (!secondary) return;

      var defaultHoverSrc = secondary.dataset.defaultSrc || '';

      // Pré-carrega imagens dos swatches na primeira vez que o mouse entra no card
      card.addEventListener('mouseenter', function () {
        card.querySelectorAll('.products-grid__swatch[data-variant-src]').forEach(function (swatch) {
          var pre = new Image();
          pre.src = swatch.dataset.variantSrc;
        });
      }, { once: true });

      // Swatch hover: troca src da imagem secundária (CSS já cuida do opacity via :hover no card)
      card.querySelectorAll('.products-grid__swatch[data-variant-src]').forEach(function (swatch) {
        swatch.addEventListener('mouseenter', function (e) {
          e.stopPropagation();
          secondary.src = swatch.dataset.variantSrc;
        });

        swatch.addEventListener('mouseleave', function () {
          secondary.src = defaultHoverSrc;
        });
      });
    });

    // Carousel automático no mobile
    function initCarousel(track) {
      if (window.innerWidth >= 750) return;

      var cards = track.querySelectorAll('.products-grid__card');
      if (cards.length < 2) return;

      var total = cards.length;
      var currentIndex = 0;
      var timer = null;

      function getCardWidth() {
        var gap = parseFloat(getComputedStyle(track).gap) || 8;
        return cards[0].offsetWidth + gap;
      }

      function goTo(index) {
        if (index >= total) index = 0;
        if (index < 0) index = total - 1;
        currentIndex = index;
        track.scrollTo({ left: currentIndex * getCardWidth(), behavior: 'smooth' });
      }

      function startAuto() {
        stopAuto();
        timer = setInterval(function () { goTo(currentIndex + 1); }, 3000);
      }

      function stopAuto() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      track.addEventListener('touchstart', stopAuto, { passive: true });
      track.addEventListener('touchend', function () {
        setTimeout(function () {
          currentIndex = Math.round(track.scrollLeft / getCardWidth());
          startAuto();
        }, 500);
      }, { passive: true });

      startAuto();
    }

    document.querySelectorAll('.products-grid__track').forEach(function (track) {
      initCarousel(track);
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products-maripha"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.related-products[data-source="auto"]');
    if (!section) return;

    var sectionId = section.dataset.sectionId;
    var productId = section.dataset.productId;
    var limit = section.dataset.limit || 4;
    if (!productId) return;

    var url = '/recommendations/products?section_id=' + sectionId
      + '&product_id=' + productId
      + '&limit=' + limit;

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newTrack = doc.querySelector('.related-products__track');
        if (!newTrack || newTrack.children.length === 0) return;

        var currentTrack = section.querySelector('.related-products__track');
        if (currentTrack) {
          currentTrack.innerHTML = newTrack.innerHTML;
          initCards(section);
        }
      })
      .catch(function () {});

    function initCards(root) {
      root.querySelectorAll('.products-grid__card').forEach(function (card) {
        var secondary = card.querySelector('.products-grid__img--secondary');
        if (!secondary) return;
        var defaultHoverSrc = secondary.dataset.defaultSrc || '';

        card.addEventListener('mouseenter', function () {
          card.querySelectorAll('.products-grid__swatch[data-variant-src]').forEach(function (sw) {
            new Image().src = sw.dataset.variantSrc;
          });
        }, { once: true });

        card.querySelectorAll('.products-grid__swatch[data-variant-src]').forEach(function (sw) {
          sw.addEventListener('mouseenter', function (e) {
            e.stopPropagation();
            secondary.src = sw.dataset.variantSrc;
          });
          sw.addEventListener('mouseleave', function () {
            secondary.src = defaultHoverSrc;
          });
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vitrine-maripha"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.vitrine-maripha__card').forEach(function (card) {
      var secondary = card.querySelector('.vitrine-maripha__img--secondary');
      if (!secondary) return;

      var defaultSrc = secondary.dataset.defaultSrc || '';

      card.addEventListener('mouseenter', function () {
        card.querySelectorAll('.vitrine-maripha__swatch[data-variant-src]').forEach(function (sw) {
          var pre = new Image();
          pre.src = sw.dataset.variantSrc;
        });
      }, { once: true });

      card.querySelectorAll('.vitrine-maripha__swatch[data-variant-src]').forEach(function (sw) {
        sw.addEventListener('mouseenter', function (e) {
          e.stopPropagation();
          secondary.src = sw.dataset.variantSrc;
        });
        sw.addEventListener('mouseleave', function () {
          secondary.src = defaultSrc;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
